
import { computed, defineComponent, reactive } from 'vue'

import TheInput from '@/common/components/UI/TheInput/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import TheSelect from '@/common/components/UI/TheSelect/index.vue'

import { onec } from '@/core/realisations/onec.realisation'

import {
    // required,
    requiredIf,
} from '@vuelidate/validators'
import useVuelidate from '@vuelidate/core'
import { DataState } from '@/core/classes/DataState.class'

import { OneCT } from '@/core/types/one_c.types'
import useNotifications from '@/common/composable/useNotifications'

const OPTIONS = [
    {
        id: 1,
        name: 'По датам',
    },
    {
        id: 2,
        name: 'По ID',
    },
    {
        id: 3,
        name: 'По номеру заказа',
    },
]

export default defineComponent({
    components: {
        TheInput,
        TheButton,
        TheSelect,
    },
    setup() {
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
            option_id: 1,
            //
            fromDate: null as string | null,
            toDate: null as string | null,
            ids: [null] as (number | null)[],
            orderNumbers: [null] as (string | null)[],
        })

        const data_state = reactive({
            one_c: new DataState<OneCT>({}),
        })

        const isDate = computed(() => state.option_id === 1)
        const isId = computed(() => state.option_id === 2)
        const isNumber = computed(() => state.option_id === 3)

        const ResendValidation = {
            fromDate: { required: requiredIf(() => isDate.value) },
            toDate: { required: requiredIf(() => isDate.value) },
        }
        const state_form$ = useVuelidate(ResendValidation, state)

        const getPayload = () => {
            if (isDate.value) {
                return {
                    fromDate: state.fromDate as string,
                    toDate: state.toDate as string,
                }
            }

            if (isId.value) {
                return {
                    ids: state.ids as number[],
                }
            }

            return {
                orderNumbers: state.orderNumbers as string[],
            }
        }

        const isInvalid = computed(() => {
            const isIdInvalid = isId.value && !state.ids.every((id) => id)
            const isNumberInvalid =
                isNumber.value && !state.orderNumbers.every((order_number) => order_number)
            return isIdInvalid || isNumberInvalid
        })

        const reset = () => {
            state.fromDate = null
            state.toDate = null
            state.ids = [null]
            state.orderNumbers = [null]
        }

        const resend = async () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            if (isInvalid.value) {
                notifications.notify({
                    title: 'Все поля обязательны к заполнению!',
                    type: 'danger',
                })
                return
            }

            try {
                state.is_loading = true
                await onec.resendDispatcher(getPayload())
                notifications.notify({ title: 'Заказы успешно прокинуты!', type: 'success' })
                reset()
            } catch (error) {
                notifications.notifyError({
                    error,
                    title: 'Произошла ошибка',
                })
                console.error(error)
            } finally {
                state.is_loading = false
            }
        }

        const addInput = () => {
            if (isId.value) state.ids.push(null)
            else if (isNumber.value) state.orderNumbers.push(null)
        }

        return {
            state,
            data_state,
            state_form$,
            isDate,
            isId,
            isNumber,
            addInput,
            resend,
            reset,
            OPTIONS,
        }
    },
})
